var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnitedKingdom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 160,
    r: 160,
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052b4",
    strokeWidth: 0,
    d: "M33.07 62.59a159.417 159.417 0 0 0-27.56 55.67h83.24L33.08 62.59Zm281.42 55.67a159.417 159.417 0 0 0-27.56-55.67l-55.67 55.67h83.24ZM5.51 201.74c5.52 20.47 15 39.32 27.56 55.67l55.67-55.67H5.51Zm251.9-168.66c-16.35-12.57-35.2-22.05-55.67-27.56v83.24l55.67-55.67ZM62.59 286.92c16.35 12.57 35.2 22.05 55.67 27.56v-83.24l-55.67 55.67ZM118.26 5.51a159.417 159.417 0 0 0-55.67 27.56l55.67 55.67V5.51Zm83.48 308.98a159.417 159.417 0 0 0 55.67-27.56l-55.67-55.67v83.24Zm29.51-112.75 55.67 55.67c12.57-16.35 22.05-35.2 27.56-55.67h-83.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.64 139.13H180.87V1.35C174.04.46 167.07 0 160 0s-14.04.47-20.87 1.35v137.78H1.35a161.381 161.381 0 0 0-.01 41.74h137.78v137.78c6.83.89 13.8 1.36 20.87 1.36s14.04-.46 20.87-1.36V180.88h137.78c.89-6.83 1.36-13.8 1.36-20.87s-.46-14.04-1.36-20.87Z",
    fill: "#d80027",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.74 201.74 71.4 71.4c3.28-3.28 6.42-6.71 9.4-10.27l-61.13-61.13h-19.68Zm-83.48 0-71.4 71.4c3.28 3.28 6.71 6.42 10.27 9.4l61.13-61.13v-19.67Zm0-83.48-71.4-71.4c-3.28 3.28-6.42 6.71-9.4 10.27l61.13 61.13h19.68Zm83.48 0 71.4-71.4c-3.28-3.28-6.71-6.42-10.27-9.4l-61.13 61.13v19.68Z",
    fill: "#d80027",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedKingdom);
export default __webpack_public_path__ + "static/media/United Kingdom.b9ffb6ce2742ab241d9f4b7b91b3d628.svg";
export { ForwardRef as ReactComponent };